import React, { Fragment, useEffect, useState } from 'react'
import Review from './Review'
import { db } from '../firebase'
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2'
import Pagination from "react-js-pagination";
import StarPicker from 'react-star-picker';




const Reviews = () => {

    const [currentId, setCurrentId] = useState('')

    const addOrEditLink = async (linkObject) => {
        try {
            if (currentId === '') {
                await db.collection('reviews').doc().set(linkObject)
                Toast.fire({
                    icon: 'success',
                    type: 'info',
                    background: "#fff",
                    title: "Review added successfully"
                });
            } else {
                await db.collection('posts').doc(currentId).update(linkObject);
                Toast.fire({
                    icon: 'success',
                    type: 'info',
                    background: "#fff",
                    title: "Review updated successfully"
                });
                setCurrentId('');
                setShow(false);

            }
            setShow(false);

        } catch (error) {
            console.log(error)
        }
    }

    const getDate = () => {

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        return today
    }
    const [rating, setRating] = useState(null);

    const getRaiting = (value) => {
        setRating(value);
    };

   
    const [customerName,setCustomerName] =useState('');
    const [customerLocation,setCustomerLocation] = useState('')
    const [customerEmail,setCustomerEmail] = useState('')
    const [dateEvent,setDateEvent] = useState('')
    const [projectDescription,setProjectDescription] = useState('')
    const [responses,setResponses]=  useState('')

    const handleCustomerName = e => {
        const { value } = e.target;       
        setCustomerName(value);
    }

    const handleCustomerLocation = e => {
        const { value } = e.target;       
        setCustomerLocation(value);
    }

    const handleCustomerEmail = e => {
        const { value } = e.target;       
        setCustomerEmail(value);
    }

    

    const handleProjectDescription = e => {
        const { value } = e.target;       
        setProjectDescription(value);
    }

   

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500
    });

 

  

    const handlerSubmit = () => {

        const review = {
            customerEmail: customerEmail,
            customerLocation: customerLocation,
            dateEvent: getDate(),
            rating:rating,
            customerName:customerName,
            projectDescription:projectDescription,
            responses: [],
        }

            addOrEditLink(review);
            window.location.reload();

    }



    const [reviews, setReviews] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    


    const getReviews = async () => {
        await db.collection('reviews').onSnapshot((querysnapshot) => {
            const docs = []
            querysnapshot.forEach(doc => {
                docs.push({ ...doc.data(), id: doc.id })
            });
            setReviews(docs)
        })
    }


 



    useEffect(() => {
        getReviews()
        getDate()
    }, [])

    return (
        <Fragment>
            <div className="containerReviews">
                <div className="containerTitle">
                    <h1 style={{ fontSize: '30px', color: '#101010' }} className='titleStep'>Reviews by our clients</h1>

                </div>
                <pre className='preListaServicios'>
                    {
                        reviews.map((review, index) => (

                            <Review rating={review.rating} response={review.responses} author={review.customerName} location={review.customerLocation} dateComment={review.dateEvent} text={review.projectDescription}></Review>

                        ))
                    }


                </pre>
                <div style={{ height: '30px' }}></div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button variant="primary" className='botonReview' onClick={handleShow}>
                        Write a review
                    </Button>
                </div>



                <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Make a review</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <div style={{ textAlign: 'center' }}>



                            <input onChange={handleCustomerName} placeholder='Your name' class="form-control mb-4" type="text" name="customerName" />
                            <input onChange={handleCustomerEmail} placeholder='Your email' class="form-control mb-4" type="email" name="customerEmail" />
                            <input onChange={handleCustomerLocation} placeholder='Your location' class="form-control mb-4" type="text" name="customerLocation" />
                            <textarea onChange={handleProjectDescription} placeholder='Write your review' class="form-control mb-4" name="projectDescription" />
                            <StarPicker onChange={getRaiting} value={rating} />



                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='btn btn-secondary m-2' onClick={handleClose}>
                            Close
                     </Button>
                        <Button onClick={handlerSubmit} className='btn btn-success m-2'>Add review</Button>
                    </Modal.Footer>
                </Modal>


            </div>




        </Fragment>
    )

}

export default Reviews